import { lazyWithChunkReload } from '../utils/lazy-with-chunk-reload';

/** Async chunk for the signed-out 404 page (UX-910) — use with `<Suspense>` in route config. */
export const Http404Lazy = lazyWithChunkReload(() => import('./http404'));
